

export enum YoGameEnvironmentRoles{
  ViewPlayers = "ViewPlayers",
  EditPlayers = "EditPlayers",
  CopyPlayers = "CopyPlayers",
  ServicePlayers = "ServicePlayers"
}
